import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from './firebase';

export const uploadArtworkImage = async (file: File, userId: string): Promise<string> => {
  const timestamp = Date.now();
  const fileName = `${userId}_${timestamp}_${file.name}`;
  const storageRef = ref(storage, `artworks/${fileName}`);
  
  await uploadBytes(storageRef, file);
  const downloadURL = await getDownloadURL(storageRef);
  
  return downloadURL;
};

export const uploadProfileImage = async (file: File, userId: string): Promise<string> => {
  const timestamp = Date.now();
  const fileName = `${userId}_${timestamp}_${file.name}`;
  const storageRef = ref(storage, `profiles/${fileName}`);
  
  await uploadBytes(storageRef, file);
  const downloadURL = await getDownloadURL(storageRef);
  
  return downloadURL;
};